import {TrustBlockContent} from '../TrustBlockContent'

export const WorryFree = () => {
  return <TrustBlockContent prefix="worryFree" defaultText="Flexible scheduling and refunds" />
}
